// @ts-nocheck
import Order from '@/view-model/modal-order-info/OrderInfoVM';
import { orderEvent, orderStatus, } from '@/constants';
import { ORDER_EVENT_TIMER } from '@/constants/global';
import OrderPolicy from '@/helpers/OrderPolicy';
import { mergeOrder } from '@/utils';
const ACCEPT_GROUP = 'accept';
const ALLOCATE_GROUP = 'allocate';
const PICKUP_GROUP = 'pickup';
const deleteOrder = (state, orderGroup, orderId) => {
    state.orderTable[orderGroup] = {
        ...state.orderTable[orderGroup],
        [orderId]: null,
    };
};
const deleteOrderAction = (...args) => setTimeout(() => {
    deleteOrder(...args);
}, ORDER_EVENT_TIMER);
const updateOrder = (state, orderGroup, orderId) => {
    const order = state.orderTable[orderGroup][orderId];
    if (order) {
        state.orderTable[orderGroup] = {
            ...state.orderTable[orderGroup],
            [orderId]: {
                ...order,
                eventActionId: null,
            },
        };
    }
};
const updateOrderAction = (...args) => setTimeout(() => {
    updateOrder(...args);
}, ORDER_EVENT_TIMER);
const setOrderAction = (state, orderGroup, order, eventAction) => {
    const { orderId, eventActionId: oldEventActionId } = order;
    oldEventActionId && clearTimeout(oldEventActionId);
    const eventActionId = eventAction(state, orderGroup, orderId);
    state.orderTable[orderGroup] = {
        ...state.orderTable[orderGroup],
        [orderId]: {
            ...order,
            eventActionId,
        },
    };
};
const isDiscardOrder = (oldOrder, newOrder) => {
    if (!oldOrder) {
        return false;
    }
    if (oldOrder.updatedAt <= newOrder.updatedAt) {
        return false;
    }
    return true;
};
const assignPendingOrder = (state, order) => {
    const { orderId, isPending = false } = order;
    const pendingOrder = state.pendingOrder[orderId];
    if (pendingOrder) {
        if (isDiscardOrder(pendingOrder, order)) {
            return true;
        }
        state.pendingOrder = {
            ...state.pendingOrder,
            [orderId]: {
                ...pendingOrder,
                ...order,
            },
        };
        return true;
    }
    if (isPending) {
        state.pendingOrder = {
            ...state.pendingOrder,
            [orderId]: order,
        };
        return true;
    }
    return false;
};
const performOrderAction = ({ state, group, oldOrder = null, newOrder = null, orderAction, }) => {
    if (isDiscardOrder(oldOrder, newOrder)) {
        return null;
    }
    const order = {
        ...oldOrder,
        ...newOrder,
    };
    setOrderAction(state, group, order, orderAction);
    return order;
};
const handlers = {
    [orderEvent.ACCEPTED]: (state, order) => {
        if (assignPendingOrder(state, order)) {
            return;
        }
        performOrderAction({
            state,
            group: ACCEPT_GROUP,
            newOrder: order,
            orderAction: updateOrderAction,
        });
    },
    [orderEvent.WORKER_REQUEST]: (state, order) => {
        const { orderId, isPending = false } = order;
        const acceptOrder = state.orderTable.accept[orderId];
        if (!acceptOrder) {
            return;
        }
        const isTheOrderCaredForByMe = OrderPolicy.isTheOrderCaredForByMe(order);
        const statusCode = isTheOrderCaredForByMe
            ? order.statusCode
            : orderStatus.ALLOCATED.code;
        const workerRequestOrder = {
            ...order,
            statusCode,
        };
        const orderAction = isPending || isTheOrderCaredForByMe
            ? updateOrderAction
            : deleteOrderAction;
        performOrderAction({
            state,
            group: ACCEPT_GROUP,
            oldOrder: acceptOrder,
            newOrder: workerRequestOrder,
            orderAction,
        });
    },
    [orderEvent.ALLOCATE]: (state, order) => {
        const { orderId, isPending = false } = order;
        const acceptOrder = state.orderTable.accept[orderId];
        if (acceptOrder) {
            const orderAction = isPending
                ? updateOrderAction
                : deleteOrderAction;
            // 접수탭에 이벤트 메시지를 위한 배달 아이템을 재정렬하지 않도록 추가
            const fixedPickupExpectedAtOrder = {
                ...order,
                pickupExpectedAt: acceptOrder.pickupExpectedAt,
            };
            performOrderAction({
                state,
                group: ACCEPT_GROUP,
                oldOrder: acceptOrder,
                newOrder: fixedPickupExpectedAtOrder,
                orderAction,
            });
        }
        const isTheOrderCaredForByMe = OrderPolicy.isTheOrderCaredForByMe(order);
        if (!isTheOrderCaredForByMe) {
            return;
        }
        if (assignPendingOrder(state, order)) {
            return;
        }
        performOrderAction({
            state,
            group: ALLOCATE_GROUP,
            oldOrder: acceptOrder,
            newOrder: order,
            orderAction: updateOrderAction,
        });
    },
    [orderEvent.REALLOCATE]: (state, order) => {
        const { orderId } = order;
        const allocateOrder = state.orderTable.allocate[orderId];
        if (!allocateOrder) {
            assignPendingOrder(state, order);
            return;
        }
        performOrderAction({
            state,
            group: ALLOCATE_GROUP,
            oldOrder: allocateOrder,
            newOrder: order,
            orderAction: updateOrderAction,
        });
    },
    [orderEvent.ALLOCATE_CANCEL]: (state, order) => {
        const { orderId, agencyShareInfo, isPending = false } = order;
        const orderAction = isPending
            ? updateOrderAction
            : deleteOrderAction;
        const allocateOrder = state.orderTable.allocate[orderId];
        if (allocateOrder) {
            performOrderAction({
                state,
                group: ALLOCATE_GROUP,
                oldOrder: allocateOrder,
                newOrder: order,
                orderAction,
            });
        }
        const pickupOrder = state.orderTable.pickup[orderId];
        if (pickupOrder) {
            performOrderAction({
                state,
                group: PICKUP_GROUP,
                oldOrder: pickupOrder,
                newOrder: order,
                orderAction,
            });
        }
        if (assignPendingOrder(state, order)) {
            const acceptOrder = state.orderTable.accept[orderId];
            if (!acceptOrder) {
                return;
            }
        }
        if (agencyShareInfo?.shareDisplayYn === 'N') {
            return;
        }
        performOrderAction({
            state,
            group: ACCEPT_GROUP,
            newOrder: order,
            orderAction: updateOrderAction,
        });
    },
    [orderEvent.PICKUP_ARRIVE]: (state, order) => {
        const { orderId } = order;
        const allocateOrder = state.orderTable.allocate[orderId];
        if (!allocateOrder) {
            assignPendingOrder(state, order);
            return;
        }
        performOrderAction({
            state,
            group: ALLOCATE_GROUP,
            oldOrder: allocateOrder,
            newOrder: order,
            orderAction: updateOrderAction,
        });
    },
    [orderEvent.PICKUP_FINISH]: (state, order) => {
        const { orderId, isPending = false } = order;
        const allocateOrder = state.orderTable.allocate[orderId];
        if (!allocateOrder) {
            assignPendingOrder(state, order);
            return;
        }
        const orderAction = isPending
            ? updateOrderAction
            : deleteOrderAction;
        const pickupOrder = performOrderAction({
            state,
            group: ALLOCATE_GROUP,
            oldOrder: allocateOrder,
            newOrder: order,
            orderAction,
        });
        if (assignPendingOrder(state, pickupOrder)) {
            return;
        }
        performOrderAction({
            state,
            group: PICKUP_GROUP,
            newOrder: pickupOrder,
            orderAction: updateOrderAction,
        });
    },
    [orderEvent.DROP_FINISH]: (state, order) => {
        const { orderId, isPending = false } = order;
        const orderAction = isPending
            ? updateOrderAction
            : deleteOrderAction;
        const allocateOrder = state.orderTable.allocate[orderId];
        if (allocateOrder) {
            performOrderAction({
                state,
                group: ALLOCATE_GROUP,
                oldOrder: allocateOrder,
                newOrder: order,
                orderAction,
            });
        }
        const pickupOrder = state.orderTable.pickup[orderId];
        if (pickupOrder) {
            performOrderAction({
                state,
                group: PICKUP_GROUP,
                oldOrder: pickupOrder,
                newOrder: order,
                orderAction,
            });
        }
        assignPendingOrder(state, order);
    },
    [orderEvent.CANCEL]: (state, order) => {
        const { orderId, isPending = false } = order;
        const orderAction = isPending
            ? updateOrderAction
            : deleteOrderAction;
        const acceptOrder = state.orderTable.accept[orderId];
        if (acceptOrder) {
            performOrderAction({
                state,
                group: ACCEPT_GROUP,
                oldOrder: acceptOrder,
                newOrder: order,
                orderAction,
            });
        }
        const allocateOrder = state.orderTable.allocate[orderId];
        if (allocateOrder) {
            performOrderAction({
                state,
                group: ALLOCATE_GROUP,
                oldOrder: allocateOrder,
                newOrder: order,
                orderAction,
            });
        }
        const pickupOrder = state.orderTable.pickup[orderId];
        if (pickupOrder) {
            performOrderAction({
                state,
                group: PICKUP_GROUP,
                oldOrder: pickupOrder,
                newOrder: order,
                orderAction,
            });
        }
        assignPendingOrder(state, order);
    },
    [orderEvent.UPDATE]: (state, order) => {
        const { orderId } = order;
        const acceptOrder = state.orderTable.accept[orderId];
        if (acceptOrder) {
            performOrderAction({
                state,
                group: ACCEPT_GROUP,
                oldOrder: acceptOrder,
                newOrder: order,
                orderAction: updateOrderAction,
            });
        }
        const allocateOrder = state.orderTable.allocate[orderId];
        if (allocateOrder) {
            performOrderAction({
                state,
                group: ALLOCATE_GROUP,
                oldOrder: allocateOrder,
                newOrder: order,
                orderAction: updateOrderAction,
            });
        }
        const pickupOrder = state.orderTable.pickup[orderId];
        if (pickupOrder) {
            performOrderAction({
                state,
                group: PICKUP_GROUP,
                oldOrder: pickupOrder,
                newOrder: order,
                orderAction: updateOrderAction,
            });
        }
        assignPendingOrder(state, order);
    },
};
const cleanAcceptOrder = (state) => {
    const acceptStatusCode = [
        orderStatus.ACCEPTED.code,
        orderStatus.WORKER_REQUESTED.code,
    ];
    const acceptOrder = mergeOrder(state.orderTable.accept, state.pendingOrder);
    state.orderTable.accept = Object.entries(acceptOrder)
        .filter(([, value,]) => value)
        .filter(([, { statusCode, isKeepForEventAction = false, },]) => isKeepForEventAction || acceptStatusCode.includes(statusCode))
        .reduce((acc, [key, value,]) => {
        acc[key] = value;
        acc[key].isKeepForEventAction = false;
        return acc;
    }, {});
};
const cleanAllocateOrder = (state) => {
    const allocateStatusCode = [
        orderStatus.ALLOCATED.code,
        orderStatus.PICKUP_ARRIVED.code,
    ];
    const allocateOrder = mergeOrder(state.orderTable.allocate, state.pendingOrder);
    state.orderTable.allocate = Object.entries(allocateOrder)
        .filter(([, value,]) => value)
        .filter(([, { statusCode, isKeepForEventAction = false, },]) => isKeepForEventAction || allocateStatusCode.includes(statusCode))
        .reduce((acc, [key, value,]) => {
        acc[key] = value;
        acc[key].isKeepForEventAction = false;
        return acc;
    }, {});
};
const cleanPickupOrder = (state) => {
    const pickupStatusCode = [
        orderStatus.PICKUP_FINISHED.code,
    ];
    const pickupOrder = mergeOrder(state.orderTable.pickup, state.pendingOrder);
    state.orderTable.pickup = Object.entries(pickupOrder)
        .filter(([, value,]) => value)
        .filter(([, { statusCode, isKeepForEventAction = false, },]) => isKeepForEventAction || pickupStatusCode.includes(statusCode))
        .reduce((acc, [key, value,]) => {
        acc[key] = value;
        acc[key].isKeepForEventAction = false;
        return acc;
    }, {});
};
const clearPendingOrder = (state) => {
    if (Object.keys(state.pendingOrder).length !== 0) {
        state.pendingOrder = {};
    }
};
export default {
    SET_ORDER_TABLE: (state, orderTable) => {
        Object.entries(orderTable).forEach(([key, value,]) => {
            state.orderTable[key] = value;
        });
    },
    SET_ORDER: (state, order) => {
        if (!order) {
            state.order = null;
            return;
        }
        const oldOrder = state.order;
        if (!oldOrder) {
            state.order = order;
            return;
        }
        // Order 병합
        // 신규 정보를 이전 주문으로 병합 new -> old
        Object.keys(order).forEach((key) => {
            // null등 falsy 값이어도 추가해야할 키들 별도 관리
            if (key === 'dropAddressDetail') {
                oldOrder[key] = order[key];
                return;
            }
            if (!order[key]
                && order[key] !== 0) {
                return;
            }
            oldOrder[key] = order[key];
        });
        state.order = new Order(oldOrder);
    },
    SET_ORDER_FROM_EVENT: (state, { event, order }) => {
        /* eslint-disable-next-line */
        handlers[event]?.(state, order);
    },
    SET_ORDER_HISTORY: (state, orderHistory) => {
        state.orderHistory = orderHistory;
    },
    CLEAN_ORDER_TABLE: (state) => {
        cleanAcceptOrder(state);
        cleanAllocateOrder(state);
        cleanPickupOrder(state);
        clearPendingOrder(state);
    },
    ASSIGN_PENDING_ORDER: (state, order) => {
        assignPendingOrder(state, order);
    },
    PUBLISH_ORDER_HAS_BEEN_COMPLETED: () => {
        // subscribe mutation only
    },
};
